import React from "react";
import Shell from "@/components/layout/Shell";

const PLAYER_NAV = [
    { id: "dashboard", label: "Dashboard", icon: "LayoutDashboard" },
    { id: "communities", label: "Communities", icon: "Globe" },
    { id: "servers", label: "Servers", icon: "Server" },
    { id: "clans", label: "Clans", icon: "Shield" },
    { id: "lfg", label: "LFG", icon: "Users" },
    { id: "maps", label: "Maps", icon: "Map" },
    { id: "events", label: "Events", icon: "Calendar" },
    { id: "market", label: "Market", icon: "ShoppingCart" },
    { id: "leaderboards", label: "Leaderboards", icon: "Trophy" },
    { id: "messages", label: "Messages", icon: "MessageSquare" },
    { id: "notifications", label: "Notifications", icon: "Bell" },
    { id: "connections", label: "Connections", icon: "Link" },
    { id: "support", label: "Support", icon: "LifeBuoy" },
    { id: "settings", label: "Settings", icon: "Settings" },
];

const BOTTOM_NAV = [
    { id: "dashboard", label: "Home", icon: "Home" },
    { id: "communities", label: "Community", icon: "Globe" },
    { id: "events", label: "Events", icon: "Calendar" },
    { id: "messages", label: "Messages", icon: "MessageSquare" },
    { id: "settings", label: "Profile", icon: "User" },
];

export default function PlayerLayout() {
    return <Shell mode="player" nav={PLAYER_NAV} basePath="/player" bottomNav={BOTTOM_NAV} />;
}
